import React from 'react';

import './Button.css';

const Button = (props) => {
  if(props.buttonType === 'submit') {
    return (
      <button className="button" type="submit">{ props.buttonText }</button>
    )
  } else {
    return (
      <a className="button" href={ props.buttonLink }>{ props.buttonText }</a>
    )
  }
  
};

Button.propTypes = {  
  buttonText: React.PropTypes.string.isRequired,
  buttonLink: React.PropTypes.string.isRequired
};

export default Button;


// WEBPACK FOOTER //
// ./src/components/Button.js